export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11959.78598e9b.jpg";